import { render, staticRenderFns } from "./AppHeaderEndSwitch.vue?vue&type=template&id=58192044&scoped=true&"
import script from "./AppHeaderEndSwitch.vue?vue&type=script&lang=js&"
export * from "./AppHeaderEndSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderEndSwitch.vue?vue&type=style&index=0&id=58192044&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58192044",
  null
  
)

export default component.exports